// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5829) return "static/chunks/5829-7464c749a1180ed3.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"949":"6e5408e1c343a355","3370":"d8c99a8a8550581a","6743":"ab4cb3e2da4d31b2"}[chunkId] + ".js";
};